import React from 'react';
import * as PropTypes from 'prop-types';
import { isNil } from 'lodash';
import styles from './InfoMessage.module.scss';
import { InfoMessageIcons } from 'components/InfoMessage/InfoMessageIcons';

export default function InfoMessage({ children, isShowIcon, className, type }) {
  const Icon = InfoMessageIcons[type];
  return (
    <div className={`${styles.infoMessageContainer} ${className} ${styles[type]}`}>
      {React.Children.map(children, (child) => {
        if (isNil(child)) {
          return null;
        }

        return (
          <div className={styles.infoItem}>
            {isShowIcon && <Icon className={styles.icon} />}
            <div>{child}</div>
          </div>
        );
      })}
    </div>
  );
}
InfoMessage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  isShowIcon: PropTypes.bool,
  type: PropTypes.oneOf(['info', 'error', 'danger']),
};
InfoMessage.defaultProps = {
  isShowIcon: true,
  type: 'info',
};
